import "@Styles/mandate.css";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HEADING_KEYSTAT } from "../Common/constant";
// import pdf from "@Images/pdf.png"
import arrowleft from "@Images/NewUI/Vector.png";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import { connect } from "react-redux";
import {
  payme_kfs_description,
  payme_kfs_heading,
  payme_kfs_list,
} from "../../../../src/helper/modalConstant";
import { KeyFactStatements } from "../../../Redux/ApplyLoan/action";
import { getDocumentStatus } from "../../../Redux/Manual_Kyc_Details/action";
import { withRouter } from "../../../hooks/withRouter";
import ModalBox from "../../../helper/modalBox";
import { Loader } from "../Common/Loader";
import { recordEvent } from "../../../utils/appFlyer";
import { trackKfsAccepted } from "../../../utils/ga4";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const KeyStatements = (props) => {
  const navigate = useNavigate();
  const [pdf, setPdf] = useState("");
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [isChecked, setIsChecked] = useState(false);
  const [is_enable, setIsenable] = useState(false);
  const [loader, setLoader] = useState(false);
  let querypram = new URLSearchParams(window.location.search).get("keyfrom");
  const [keyfrom, setKeyfrom] = useState(querypram);
  const [modalState, setModalState] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 440);

    useEffect(() => {
        const handleResize = () => {
            setIsLargeScreen(window.innerWidth > 440);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

  useEffect(() => {
   
    let token = localStorage.getItem("gpay_token");
    let data = {
      amount: localStorage.getItem("loanAmount"),
      applied_for_medibuddy: false,
      loan_type: localStorage.getItem("loan_type")?.toString(),
      mars_applied_for_insurance: false,
      medibuddy_package: 0,
      reason_for_loan: localStorage.getItem("loanReason")?.toString(),
      repayment_date: localStorage.getItem("repayDate"),
    };
    setLoader(true);
    props
      .KeyFactStatements(data, token)
      .then((res) => {
        // setLoader(false);
        // alert("1")
        setPdf(res.presigned_url);
        // console.log("pdfres", res.presigned_url);
      })
      .catch((err) => {
        setLoader(false);
        if (err.response?.status === 401) {
          window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
        // console.log(err);
      });
  }, []);
  const onDocumentLoadSuccess = ({ numPages }) => {
    
    setNumPages(numPages);
    // setLoader(false);
  };
  const goToPrevPage = () => setPageNumber(pageNumber - 1);

  const goToNextPage = () => setPageNumber(pageNumber + 1);

  const handleChange = (event) => {
    if (event.target.checked) {
      setIsenable(true);
    } else {
      setIsenable(false);
    }
  };
  // console.log("local", localStorage, pdf);
  const handlekyccondition = () => {
    trackKfsAccepted();
    let token = localStorage.getItem("gpay_token");
    props.getDocumentStatus(token).then((res) => {
      res.data.map((details) => {
        const userId = props.userDetail?.user_detail?.id;
        recordEvent({
          eventName: "kfs_signed",
          eventParams: { Platform: "web" },
          userId: userId,
        });
        if (details.bank_details_verified == "NOT_VALID") {
          let bankData = {
            heading: "Sorry !",
            subHeading: "Bank details could not be verified. Please try again",
            message: "",
            but_name: "Try Again",
            route: "bank",
            backbtn: "show",
          };
          navigate(
            `/not_eligible_for_loan?msg=${JSON.stringify(bankData)}`
          );
          return;
        }
        if (details.bank_details_verified == "PENDING_VERIFICATION") {
          let bankData = {
            heading: "Please Wait!",
            subHeading: "Please try after sometime",
            message: "Your bank details are in pending verification.",
            but_name: "Back to Home",
            route: "bank",
          };
          navigate(`/message?details=${JSON.stringify(bankData)}`);
          return;
        }
        if (details.bank_details_verified == "NOT_SUBMITTED") {
          navigate("/add_bank_details");
          return;
        }
        if (res.data[0].emandate_verified === "S") {
          navigate("/loandetail");
        }
        if (
          res.data[0].esign_verified === "S" &&
          res.data[0].emandate_verified === "S"
        ) {
          navigate("/loandetail?someCheck=true");
        } else {
          navigate("/autodebit");
        }
        //props.history.push("/autodebit?keyfrom=kfs")
        //props.history.push("/agreement?keyfrom=kfs");
      });
    });
  };
  return (
    <div id="background" className="main_div">
      {isLargeScreen &&
        <div className="refer-earn-new paddingkfs  headAlign  d-flex shadowline sticky-header headkfs">
           <div className="flex">
           <img
              style={{ cursor: "pointer" }}
              className="customimgfix mt-2"
              src={arrowleft}
              onClick={() => {
                // window.location.href="/dashboard_s";
                if (keyfrom === "Applyloan") {
                  navigate(-1);
                  return;
                }
                navigate(-2);
                return;
              }}
            />
            <h1
              className="boldheading"
              style={{
                paddingLeft: "27px",
                color: "#152745",
                fontWeight: "800",
                fontSize: "25px",
              }}
            >
              {HEADING_KEYSTAT}
            </h1>
            </div>
            {/* <img
              className="imageQuestionMark trnslatey5 someQuestion ml-30"
              onClick={() => {
                setModalState(true);
              }}
              src={questionImage}
            /> */}
          </div>}
      <div className="">
        <div className="pb-40">
          {/* <Heading
            headingText={HEADING_KEYSTAT}
            backprops={"/apply_loan"}
            history={props.history}
          /> */}
{!isLargeScreen &&
        <div className="  headAlign  d-flex shadowline sticky-header headkfs">
            <img
              style={{ cursor: "pointer" }}
              className="customimgfix"
              src={arrowleft}
              onClick={() => {
                // window.location.href="/dashboard_s";
                if (keyfrom === "Applyloan") {
                  navigate(-1);
                  return;
                }
                navigate(-2);
                return;
              }}
            />
            <h1
              className="boldheading"
              style={{
                paddingLeft: "27px",
                color: "#152745",
                fontWeight: "800",
                fontSize: "25px",
              }}
            >
              {HEADING_KEYSTAT}
            </h1>
            {/* <img
              className="imageQuestionMark trnslatey5 someQuestion ml-30"
              onClick={() => {
                setModalState(true);
              }}
              src={questionImage}
            /> */}
          </div>}
          {loader ? <Loader/> : " "}
          <div className="wrapper-content">
            <div className="card-height mt-30 px-4 pb-3 pt-1 w-100 text-center mx-auto outlinekfs" style={{ height: "calc(100vh - 280px)", overflowY: "scroll", overflowX: "hidden" }}>
              <div className="h-75 d-flex flex-column justify-content-between">
                <div className="pt-4 pb-5">
                  <div style={{ width: "100%", maxWidth: "100%" }}>
                    <section className="centered" style={{ width: "100%", maxWidth: "100%" }}>
                    {[...Array(numPages)]?.map((comp, index) => {
                        return (
                          <Document
                            file={pdf}
                            onLoadSuccess={onDocumentLoadSuccess}
                            renderMode="canvas"
                            loading="Preparing the document..."
                            key={index}
                          >
                            <Page
                              pageNumber={index + 1}
                              width={Math.min(window.innerWidth - 80, 350)}
                              onRenderSuccess={() => {
                                if (index + 1 === numPages) setLoader(false); 
                              }}
                            />
                          </Document>
                        );
                      })}
                    </section>
                    {/* <section className="icons-pdf">
                      <button onClick={goToPrevPage} disabled={pageNumber <= 1}>
                        <i
                          className="fa fa-long-arrow-left zindexZero"
                          aria-hidden="true"
                        ></i>
                      </button>
                      <p style={{ textAlign: "center" }}>
                        Page {pageNumber} of {numPages}
                      </p>
                      <button
                        onClick={goToNextPage}
                        disabled={pageNumber === numPages}
                      >
                        <i
                          className="fa fa-long-arrow-right zindexZero"
                          aria-hidden="true"
                        ></i>
                      </button>
                    </section> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div className="sticky-button-container">
        <div style={{ clear: "both", width: "100%" }}>
          <div className="flex flex-column align-items-center"
            style={{
              paddingTop: 5,
              clear: "both",
              width: "100%",
              paddingLeft: 20,
              // display: "flex",
              // flexDirection: "column",
              // alignItems: "center"

            }}
          >
            <label htmlFor="terms" class="main-checkk">
              I have read the above and agree to the terms
              <input
                className="Termscheckbox"
                type="checkbox"
                value={isChecked}
                onChange={handleChange}
                id="terms"
                name="terms"
              />
              <span class="geekmarkk"></span>
            </label>
          </div>
        </div>
        <div className="text-center pt-30">
          {is_enable === true ? (
            <button
              className="GetNowBtnrepayvd  zindexZero"
              onClick={handlekyccondition}
              // onClick={() => props.history.push("/agreement")}
            >
              {" "}
              Continue{" "}
            </button>
          ) : (
            <button className="GetNowBtnrepayvd zindexZero opacity-50">
              Continue
            </button>
          )}
        </div>

        </div>


        <div className="zindextop">
          {modalState && (
            <ModalBox
              modalType={"description"}
              heading={payme_kfs_heading}
              description={payme_kfs_description}
              List={payme_kfs_list}
              open={true}
              onChange={(props) => {
                setModalState(props);
              }}
              imagesVisible={true}
            />
          )}
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    user: state.user,
    userDetail: state.userDetail,
  };
};
export default withRouter(connect(mapStateToProps, {
  KeyFactStatements,
  getDocumentStatus,
})(KeyStatements));
